module.exports = __webpack_public_path__ + "img/hero_en.8ef5beb.jpg";